const countrySelectorInFooter = document.querySelector("#countrySelect");
const flagsInFooter = document.querySelectorAll('.change--shop-flag');
const switchCountryInFooter = document.querySelector('.poup-btn-procced');
const cancelSwitchInFooter = document.querySelector('.poup-btn-cancel');
const closeSwitchInFooter = document.querySelector('.poup-btn-x');
if(window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
    location.href = location.href;
}

document.addEventListener('DOMContentLoaded',function(){
    const countrySelectorContainer = document.querySelector(".country-selector-container");
    const originalState = {};
    if(countrySelectorContainer) {
        const countrySelector = countrySelectorContainer.querySelector("#country");
        const currencyCtrl = countrySelectorContainer.querySelector(".option-content.currency");
        const getOriginalState = () => {
            originalState.index = countrySelector.selectedIndex;
            originalState.flag = localStorage.getItem('flag');
            originalState.country = localStorage.getItem('country');
            originalState.currency = currencyCtrl.innerHTML;
        }
        const retrieveOriginalState = () => {
            countrySelector.selectedIndex = originalState.index;
            localStorage.setItem('flag',originalState.flag);
            localStorage.setItem('country',originalState.country);
            currencyCtrl.innerHTML = originalState.currency;
            if(countrySelectorInFooter) {
                countrySelectorInFooter.selectedIndex = originalState.index;
            }
            flagsInFooter.forEach(flag=>{
                flag.style.display = 'none';
            });
            if(flagsInFooter[originalState.index]) {
                flagsInFooter[originalState.index].style.display = '';
            }
        }
        getOriginalState();
        document.querySelectorAll(".country-selector-button").forEach(item=>{
            item.addEventListener('click',function(){
                event.preventDefault();
                var sgcr_btn = document.querySelector(".lg-sgcr-switcher .spicegems_manual-switcher");
                console.log("-----------------", sgcr_btn);
                sgcr_btn.click();
                return;
                countrySelectorContainer.style.display = 'block';
                const mobileMenuDrawer = this.closest('.header__drawer.caps');
                if(mobileMenuDrawer) {
                    mobileMenuDrawer.classList.remove("drawer--visible");
                }
                document.querySelector(".header__mobile__hamburger")?.classList.remove("drawer--visible");

            });
        });
        countrySelectorContainer.querySelector(".overlay").addEventListener('click',function(){
            countrySelectorContainer.style.display = 'none';
            retrieveOriginalState();

        });
        countrySelectorContainer.querySelector(".update_preference").addEventListener("click",function(){
            if(countrySelector) {
                switchCountry(countrySelector.value);
            }
            switchCountry();
        });
        window.switchCountry = (baseURL) => {
            if(baseURL) {
                const country = localStorage.getItem('country');
                if(country === 'International') {
                    location.href = baseURL + '?country=International';
                } else if(country === 'Canada') {
                    location.href = baseURL + '?country=CA';
                } else {
                    location.href = baseURL;
                }
            }
        }
        countrySelectorContainer.querySelector(".close").addEventListener('click',function(){
            countrySelectorContainer.style.display = 'none';
            retrieveOriginalState();
        });
        countrySelector.addEventListener('change',function(){
            const options = this.querySelectorAll("option");
            const currency = options[this.selectedIndex].getAttribute('currency');
            currencyCtrl.innerHTML = currency;
            flagsInFooter.forEach(flag=>{
                flag.style.display = 'none';
            });
            if(flagsInFooter[this.selectedIndex]) {
                flagsInFooter[this.selectedIndex].style.display = '';
            }
            if(countrySelectorInFooter) {
                countrySelectorInFooter.selectedIndex = this.selectedIndex;
            }
            if(this.selectedIndex === 1) {
                localStorage.setItem('country','Canada');
            } else if(this.selectedIndex === 2) {
                localStorage.setItem('country','International');
            }
        });
        countrySelectorInFooter?.addEventListener("change",function(){
            const options = countrySelector.querySelectorAll("option");
            const currency = options[this.selectedIndex].getAttribute('currency');
            currencyCtrl.innerHTML = currency;
            flagsInFooter.forEach(flag=>{
                flag.style.display = 'none';
            });
            if(flagsInFooter[this.selectedIndex]) {
                flagsInFooter[this.selectedIndex].style.display = '';
            }
            if(countrySelectorInFooter) {
                countrySelectorInFooter.selectedIndex = this.selectedIndex;
            }
            if(this.selectedIndex === 0) {
                localStorage.setItem('country','USA');
            } else if(this.selectedIndex === 1) {
                localStorage.setItem('country','Canada');
            } else if(this.selectedIndex === 2) {
                localStorage.setItem('country','International');
            }
        });
        switchCountryInFooter?.addEventListener('click',function(e){
            e.preventDefault();
            switchCountry();
        });
        cancelSwitchInFooter?.addEventListener('click',function(){
            countrySelectorContainer.style.display = 'none';
            retrieveOriginalState();
        });
        closeSwitchInFooter?.addEventListener('click',function(){
            countrySelectorContainer.style.display = 'none';
            retrieveOriginalState();
        });
    }
    
}); 



document.addEventListener("DOMContentLoaded", function() {
    var timer;
    var timer_nav;

    
    timer_nav = setInterval(function() {
        if(document.querySelectorAll(".spicegems_switcher_modal .spicegems_switcher_listItem")) {
            document.querySelectorAll(".spicegems_switcher_modal .spicegems_switcher_listItem").forEach(item => {
                item.addEventListener("click", function() {
                    var txt = document.querySelector(".spicegems_switcher_modal .spicegems_switcher_dropdown .spicegems_switcher_rule-name").innerHTML;
                    if(txt == "International") {
                        console.log("current-country", txt);
                        localStorage.setItem('flag',document.querySelector("#international_mark").value);
                        localStorage.setItem('country','International');
                    } else {
                        localStorage.setItem('flag',document.querySelector("#current_country_flag").value);
                        localStorage.setItem('country','USA');
                    }
                });
            });
            clearInterval(timer_nav);
        }
    }, 1000);

    timer = setInterval(function() {
        var switcher = document.querySelector(".sgcr-contry-switcher");
        
        document.querySelectorAll(".spicegems_switcher-button-wrapper .spicegems_switcher_listItem").forEach(item => {
            item.addEventListener("click", function() {
                var txt = document.querySelector(".spicegems_switcher-button-wrapper .spicegems_switcher_rule-name").innerHTML;
                console.log("current-country", txt);
                if(txt == "International ($CAD)") {
                    localStorage.setItem('flag',document.querySelector("#international_mark").value);
                    localStorage.setItem('country','International');
                } else {
                    localStorage.setItem('flag',document.querySelector("#current_country_flag").value);
                    localStorage.setItem('country','USA');
                }
            });
        });

        if (switcher) {
            if(switcher.querySelector(".spicegems_switcher_list")) {
                if(localStorage.getItem('country') == "International") {
                  switcher.querySelector(".spicegems_switcher_dropdown .spicegems_switcher_rule-name").innerHTML = "International ($CAD)";
                }else {
                  switcher.querySelector(".spicegems_switcher_dropdown .spicegems_switcher_rule-name").innerHTML = "USA ($USD)";
                }
                clearInterval(timer);
            }
        }
    }, 1000);
});